const schemePrefixPattern = /^[a-zA-Z]+:/;
export default function imageIdToURI(imageId) {
    if (!imageId) {
        return '';
    }
    const firstPrefixMatch = imageId.match(schemePrefixPattern);
    if (!firstPrefixMatch) {
        return imageId;
    }
    const remainder = imageId.substring(firstPrefixMatch[0].length);
    if (!schemePrefixPattern.test(remainder)) {
        return imageId;
    }
    return remainder;
}
